import { Lock } from 'lucide-react'
import { Button } from 'shared/ui/button'
import { Card, CardContent } from 'shared/ui/card'
import { Checkbox } from 'shared/ui/checkbox'

interface ClosePermitBulkActionsProps {
  isAllSelected: boolean
  selectedCount: number
  selectableCount: number
  onToggleSelectAll: (checked: boolean) => void
  onMassClose: () => void
}

export function ClosePermitBulkActions({
  isAllSelected,
  selectedCount,
  selectableCount,
  onToggleSelectAll,
  onMassClose,
}: ClosePermitBulkActionsProps) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="flex flex-col gap-3 p-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3 text-sm text-slate-600">
          <Checkbox checked={isAllSelected} onCheckedChange={(checked) => onToggleSelectAll(checked === true)} />
          <span>เลือกทั้งหมดเฉพาะรายการ OPENED ({selectedCount}/{selectableCount})</span>
        </div>
        <Button
          className="bg-rose-500 text-white hover:bg-rose-600"
          disabled={selectedCount === 0}
          onClick={onMassClose}
        >
          <Lock className="mr-2 h-4 w-4" />
          ปิด Permit หลายรายการ ({selectedCount})
        </Button>
      </CardContent>
    </Card>
  )
}
